document.addEventListener("DOMContentLoaded", function () {

  const picker = document.querySelector("[id^='CustomVariantPicker-']");
  if (!picker) return;

  const sectionId = picker.id.replace("CustomVariantPicker-", "");
  const variants = JSON.parse(
    document.getElementById(`ProductVariants-${sectionId}`).textContent
  );

  const selects = picker.querySelectorAll("select");
  const form = document.querySelector(`#product-form-${sectionId}`);
  const variantInput = form.querySelector("input[name='id']");
  const priceContainer = document.querySelector(`#price-${sectionId}`);

  function findMatchingVariant() {
    const selectedOptions = Array.from(selects).map(s => s.value);

    return variants.find(variant => {
      return variant.options.every((opt, i) => opt === selectedOptions[i]);
    });
  }

  function updateVariant() {
    const variant = findMatchingVariant();

    if (!variant) return;

    // Update hidden input
    variantInput.value = variant.id;

    // Update price
    if (priceContainer) {
      priceContainer.innerHTML = Shopify.formatMoney(
        variant.price,
        window.theme.moneyFormat
      );
    }

    // Update URL
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?variant=${variant.id}`
    );

    // Enable / Disable button
    const submitBtn = form.querySelector("button[type='submit']");
    if (variant.available) {
      submitBtn.disabled = false;
      submitBtn.textContent = "Add to cart";
    } else {
      submitBtn.disabled = true;
      submitBtn.textContent = "Sold Out";
    }
  }

  selects.forEach(select => {
    select.addEventListener("change", updateVariant);
  });

  // Init on load
  updateVariant();

});
